import {
  CRITERION_VALUE,
  type CriterionValue,
} from "@/constants/criterion-values"

export interface CriterionResult {
  criterion: string
  result: CriterionValue
  explanation: string
}

const VALID_CRITERION_RESULTS: readonly CriterionValue[] = [
  CRITERION_VALUE.MET,
  CRITERION_VALUE.NOT_MET,
  CRITERION_VALUE.UNKNOWN,
]

export function isValidCriterionResult(
  value: unknown,
): value is CriterionValue {
  return (
    typeof value === "string" &&
    VALID_CRITERION_RESULTS.includes(value as CriterionValue)
  )
}
